import { Controller } from "@hotwired/stimulus";

// Connects a list of agents (e.g. the structure manager sidebar) to a tree
// rendered by the `tree` controller. Clicking an agent jumps to and highlights
// that agent's node in the tree.
export default class extends Controller {
  static outlets = ["tree"];

  jump(event) {
    const agentId = event.params.agentId;

    if (!this.hasTreeOutlet || agentId === undefined || agentId === null) {
      return;
    }

    this.treeOutlet.revealAgentNode(agentId);
  }
}
